import React, { Component } from 'react';
import { Button, Col, Row, Card, CardBody, CardHeader, Table } from 'reactstrap';
import './style.scss';
import AuthService from '../../../components/Services/AuthService';
import ScorecardService from '../../../components/Services/ScorecardServices/scorecardservice';
import withAuth from '../../../components/Services/WithAuth';
import { riskFactorType } from './helper';

class ViewScorecardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            value: '',
            suggestions: [],
            modifyFlag: true,
            scorecardId: null,
            scoreDetails: {
                templateName: '',
                corporateName: '',
                counterpartyType: ''
            },
            // riskGrades: '',
            financialList: null,
            nonFinancialList: null,
            // overrideList: null,
            riskGrade: null,
            deleteSuccess: false,
            modal: false
        };
        this.Auth = new AuthService();
        this.ScoreAuth = new ScorecardService();
        this.token = localStorage.getItem('id_token');

    }

    componentDidMount() {
        const scoreId = this.props.match.params.scorecardid; //this.props.location.search;
        if (scoreId) {
            this.setState({
                scorecardId: scoreId//scoreId.slice(4, scoreId.length)
            }, () => {
                this.ScoreAuth.getScorecardDetails(this.state.scorecardId).then(result => {
                    this.setState({
                        scoreDetails: result.data
                    }, () => {
                        this.updateData();
                    })
                }).catch(error => {
                    /* if (error.response.status === 401) {
                        this.handleAuthorization();
                    } */
                })
            })
        } else {
            this.props.history.push('/scorecard/search');
        }
    }
    updateData = () => {
        const riskData = riskFactorType(this.state.scoreDetails.riskfactors);
        this.setState({
            riskGrade: this.state.scoreDetails.riskGrades.map(p => {
                return (
                    <tr className="grey2" key={p.riskGrade} >
                        {Object.keys(p).filter(k => k !== 'id').map(k => {
                            return (
                                <td className="grey1" key={p.riskGrade + '' + k}>
                                    <div name={p[k]} value={p[k]}>
                                        {p[k]}
                                    </div>
                                </td>);
                        })}
                    </tr>
                );
            }),
            financialList: riskData[0].financialData.map(p => {
                return (
                    <tr key={p.riskFactorName}>
                        {
                            Object.keys(p).filter(k => k !== 'id').map(k => {
                                return (<td key={k}>{p[k]}</td>);
                            })
                        }
                    </tr>
                );
            }),
            nonFinancialList: riskData[0].nonFinancialData.map(p => {
                return (
                    <tr key={p.riskFactorName}>
                        {
                            Object.keys(p).filter(k => k !== 'id').map(k => {
                                return (<td key={k}>{p[k]}</td>);
                            })
                        }
                    </tr>
                );
            }),
        });
    }
    handleCancel = (event) => {
        event.preventDefault();
        this.props.history.push('/scorecard/search');
    }
    handleModifyScorecard = (event) => {
        this.props.history.push(`/scorecard/edit/${this.state.scorecardId}`)
    }
    handleDelete = (event) => {
        event.preventDefault();
        this.ScoreAuth.deleteScorecard(this.state.scorecardId).then(() => {
            this.setState({
                deleteSuccess: !this.state.deleteSuccess
            })
        }).catch(error => {
            if (error.status === 401) {
                this.handleAuthorization();
            }
        })
    }
    deleteSuccess = () => {
        this.props.history.push('/scorecard/search');
    }
    handleAuthorization = () => {
        this.setState({
            modal: !this.state.modal
        })
    }
    handleLogout = () => {
        this.Auth.logout();
        this.props.history.push('../../login');
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                Scorecard
                            </h4>
                            <span>
                                <Button outline size="sm" color="primary" className="mr-3" title="Edit Scorecard" onClick={(event) => this.handleModifyScorecard(event)}><i className="icon-edit"></i> </Button>
                                <Button outline size="sm" color="primary" title="Delete Scorecard" onClick={this.handleDelete}><i className="icon-delete"></i> </Button>
                            </span>
                        </div>
                        <Card className="mb-4">
                            <CardHeader className="header-blue">
                                <Row>
                                    <Col>Name</Col>
                                    <Col>Corporate Name</Col>
                                    <Col>Counterparty Type</Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col>{this.state.scoreDetails.templateName}</Col>
                                    <Col>{this.state.scoreDetails.corporateName}</Col>
                                    <Col>{this.state.scoreDetails.counterpartyType}</Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="mb-4">
                            <CardHeader className="header-blue">
                                <h6 className="mb-0">Financial Factors</h6>
                            </CardHeader>
                            <CardBody className="d-flex text-left justify-content-between p-0">
                                <Table bordered className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Factor</th>
                                            <th>Weight</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.financialList}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                        <Card className="mb-4">
                            <CardHeader className="header-blue">
                                <h6 className="mb-0">Non-Financial Factors</h6>
                            </CardHeader>
                            <CardBody className="d-flex text-left justify-content-between p-0">
                                <Table bordered className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Factor</th>
                                            <th>Weight</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.nonFinancialList}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                        <Card className="mb-4">
                            <CardHeader className="header-blue">
                                <h6 className="mb-0">Risk Grades</h6>
                            </CardHeader>
                            <CardBody className="d-flex text-left justify-content-between p-0">
                                <Table bordered className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Score - Min</th>
                                            <th>Score - Max</th>
                                            <th>Grade Name</th>
                                            <th>Grade Description</th>
                                            <th>PD</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.riskGrade}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Col>
        );
    }
}
export default withAuth(ViewScorecardComponent);
